import { OnboardingBenefitsStep } from "@/blocks/OnboardingBenefitsStep";
import { OnboardingConcernsStep } from "@/blocks/OnboardingConcernsStep";
import { OnboardingNextStepsStep } from "@/blocks/OnboardingNextStepsStep";

import { OnboardingVariantType } from "../types";
import { IntroStepWithImage } from "./IntroStepWithImage";

export const introStepWithImageVariant: OnboardingVariantType = {
  steps: [
    { Component: IntroStepWithImage, footerTone: "dark" },
    { Component: OnboardingBenefitsStep },
    { Component: OnboardingConcernsStep },
    { Component: OnboardingNextStepsStep },
  ],
};
